import o, { css as t } from "styled-components";
import p from "../Icons/Card.js";
import a from "../Icons/Paypal.js";
const n = o.div``, s = o(n)`
  margin-bottom: 23px;
`, r = t`
  height: 40px;
  width: 70px;
  margin-right: 8px;
`, c = o(a)`
  ${r};
`, d = o(p)`
  ${r};
`, g = o.span`
  display: flex;
  align-items: center;
`;
export {
  n as BaseWrapper,
  s as HeadingWrapper,
  d as IconCard,
  c as IconPaypal,
  g as ItemWrapper
};
